import {CreateSheet} from 'aphrodite';
import {ElementBg, InputBg, TextColor, Secondary} from 'src/themes/colors';

export default CreateSheet({
    main: {
        position: 'fixed',
        background: 'rgba(0, 0, 0, 0.5)',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'auto',
        zIndex: 10000001,
    },
    mainExtra: {
        position: 'absolute',
        zIndex: 100,
    },
    warningLightbox: {
        zIndex: 10000002,
    },
    block: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        padding: '30px 20px 40px 20px',
        fontSize: '1.0714rem',
        fontWeight: 400,
        color: TextColor,
        backgroundColor: ElementBg,
        borderRadius: '20px 20px 0 0',
        zIndex: 2,
        '@media(max-width: 640px)': {
            padding: '20px 20px 40px 20px',
        },
    },
    blockContent: {
        width: 800,
        maxWidth: '100%',
        margin: '0 auto',
    },
    wrapper: {
        width: 690,
        maxWidth: '100%',
        maxHeight: '100vh',
        padding: 20,
    },
    lightbox: {
        position: 'relative',
        width: '100%',
        maxHeight: 'calc(100vh - 40px)',
        padding: 30,
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.4,
        borderRadius: 9,
        color: TextColor,
        backgroundColor: ElementBg,
        overflow: 'auto',
    },
    btnIconDetails: {
        display: 'block',
        marginRight: 10,
    },
    close: {
        position: 'absolute',
        top: 30,
        right: 30,
        padding: 3,
        borderRadius: 0,
        zIndex: 2,
    },
    title: {
        margin: 0,
        fontSize: '1.5714rem',
        fontWeight: 600,
        '@media(max-width: 640px)': {
            fontSize: '1.2857rem',
        },
    },
    text: {
        margin: '5px 0 0 0',
    },
    textLight: {
        color: Secondary,
    },
    link: {
        color: TextColor,
        fontWeight: 600,
        textDecoration: 'underline',
    },
    warning: {
        marginTop: 15,
        fontSize: '0.9285rem',
        fontWeight: 500,
    },
    nav: {
        display: 'flex',
        marginTop: 15,
        gap: 10,
        '@media(max-width: 640px)': {
            flexDirection: 'column',
        },
    },
    btn: {
        width: '33.333%',
        '@media(max-width: 640px)': {
            width: '100%',
        },
    },
    btnIconBlock: {
        display: 'block',
        width: 14,
        height: 14,
        marginRight: 10,
    },
    btnIcon: {
        transform: 'rotate(0)',
        transition: 'transform 0.25s',
    },
    btnIconOpened: {
        transform: 'rotate(-180deg)',
    },
    detailsList: {
        margin: '15px 0 0 0',
        padding: 0,
        listStyle: 'none',
    },
    detailsItemTitle: {
        display: 'flex',
        height: 50,
        padding: '0 20px',
        fontSize: '1rem',
        fontWeight: 600,
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    detailsItemTitleLeft: {
        display: 'flex',
        height: 17,
        padding: 0,
        fontSize: '1rem',
        fontWeight: 600,
        color: TextColor,
        border: 0,
        background: 'transparent',
        boxShadow: 'none',
        alignItems: 'center',
        cursor: 'pointer',
    },
    checkboxParent: {
        padding: 0,
        border: 0,
        background: 'transparent',
        boxShadow: 'none',
    },
    detailsItemTitleLabel: {
        padding: '5px 10px',
        fontSize: '0.8571rem',
        fontWeight: 500,
        textTransform: 'uppercase',
        background: InputBg,
    },
    detailsItem: {
        padding: '10px 20px 10px 45px',
        fontSize: '0.8571rem',
        background: InputBg,
    },
    detailsItemCookie: {
        margin: '10px 0',
        ':first-child': {
            marginTop: 0,
        },
        ':last-child': {
            marginBottom: 0,
        },
    },
    detailsNav: {
        display: 'flex',
        marginTop: 15,
        justifyContent: 'flex-end',
    },
});
